"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _headline = _interopRequireDefault(require("../../components/headline"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _rating = _interopRequireDefault(require("./rating"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  departmentTitle: {
    ...theme.customTypography.teamDepartmentTitle
  },
  employee: {
    alignItems: "center",
    background: theme.palette.background.light,
    marginBottom: theme.spacing(4),
    padding: theme.spacing(4, 3)
  },
  employeeTitle: {
    ...theme.customTypography.teamEmployeeTitle
  },
  image: {
    borderRadius: "50%",
    display: "block",
    height: "100%",
    margin: "0 auto",
    maxHeight: 240,
    maxWidth: 240,
    objectFit: "cover",
    width: "100%"
  },
  imagePlaceholder: {
    background: "rgba(255, 255, 255, 0.6)",
    borderRadius: "50%",
    height: 120,
    width: 120
  },
  contentWrapper: {
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    justifyContent: "center",
    marginTop: theme.spacing(4)
  }
}));
const Employee = props => {
  const [employee, setEmployee] = (0, _react.useState)({});
  const {
    lang
  } = props;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    async function fetchData() {
      const {
        REACT_APP_PATH
      } = process.env;
      const response = await fetch("".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/EmployeeDetails.api?lang=").concat(lang, "&pagename=").concat(window.location.pathname));
      setEmployee(await response.json());
    }
    fetchData();
  }, [lang]);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  if ((0, _lodash.isEmpty)(employee)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const {
    id,
    firstName,
    groups,
    lastName,
    media,
    profilePicture,
    descriptions,
    ratingActive,
    urls = []
  } = employee;
  let name = null;
  if (firstName && lastName) {
    name = firstName + " " + lastName;
  } else if (firstName) {
    name = firstName;
  } else if (lastName) {
    name = lastName;
  }
  const m = profilePicture ? profilePicture : (0, _lodash.first)(media);
  let image = null;
  if (m && m.filename) {
    image = /*#__PURE__*/_react.default.createElement("img", {
      className: css.image,
      src: m.filename,
      alt: name,
      loading: "lazy"
    });
  } else {
    image = /*#__PURE__*/_react.default.createElement("div", {
      className: css.imagePlaceholder
    });
  }
  const groupsAsString = groups === null || groups === void 0 ? void 0 : groups.map(item => {
    return item.title;
  }).join(", ");
  const jobTitlesAsString = groups === null || groups === void 0 ? void 0 : groups.map(item => {
    return item.addition;
  }).join(", ");
  let description = null;
  if (descriptions) {
    var _descriptions$find;
    description = descriptions === null || descriptions === void 0 || (_descriptions$find = descriptions.find(desc => desc.type === "standard")) === null || _descriptions$find === void 0 ? void 0 : _descriptions$find.description;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    lang: i18n.language,
    title: name
  }), /*#__PURE__*/_react.default.createElement(_headline.default, {
    data: {
      text: groupsAsString
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.employee
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 4
  }, image), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 8,
    className: css.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.employeeTitle,
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: jobTitlesAsString
    }
  }))), description && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), urls.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: css.links
  }, urls === null || urls === void 0 ? void 0 : urls.map((item, index) => {
    const {
      title,
      url
    } = item;
    return /*#__PURE__*/_react.default.createElement("a", {
      className: css.link,
      key: index,
      href: url,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      color: "primary",
      variant: "contained",
      size: "small"
    }, title));
  })), ratingActive ? /*#__PURE__*/_react.default.createElement(_rating.default, {
    name: name,
    employeeID: id
  }) : "");
};
var _default = exports.default = Employee;